import { Send } from "lucide-react";
import { useLeadModal } from "@/context/LeadModalContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_e777b62c-b27f-4f59-b756-d66b6d874b9e/artifacts/uwo9arpc_logo%20thegoldfx.png";

export default function Header() {
  const { openModal } = useLeadModal();

  return (
    <header
      data-testid="site-header"
      className="fixed left-0 right-0 top-0 z-50 backdrop-blur-xl"
      style={{
        background: "rgba(5, 5, 5, 0.6)",
        borderBottom: "1px solid rgba(255, 215, 0, 0.12)",
      }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <a
          href="#top"
          data-testid="header-brand-link"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO_URL}
            alt="THE GOLD FX logo"
            data-testid="header-logo"
            className="h-10 w-10 object-contain sm:h-12 sm:w-12"
            style={{
              filter: "drop-shadow(0 0 12px rgba(255,215,0,0.35))",
            }}
          />
          <div className="leading-tight">
            <div
              className="font-heading text-sm font-black uppercase tracking-[0.18em] sm:text-base"
              data-testid="header-brand-name"
            >
              <span className="text-gradient-gold">THE GOLD FX</span>
            </div>
            <div className="font-heading text-[10px] font-semibold uppercase tracking-[0.3em] text-cyan-400/80 sm:text-xs">
              AI POWERED
            </div>
          </div>
        </a>

        <button
          type="button"
          onClick={openModal}
          data-testid="header-telegram-cta"
          className="hidden items-center gap-2 rounded-full border border-yellow-400/60 bg-yellow-400/10 px-4 py-2 font-heading text-xs font-bold uppercase tracking-wider text-yellow-300 transition-all duration-300 hover:bg-yellow-400/20 hover:text-yellow-200 sm:inline-flex"
        >
          <Send className="h-3.5 w-3.5" />
          Telegram
        </button>
      </div>
    </header>
  );
}
